<script lang="ts" setup>
import { Badge } from '@vue-interface/badge';
import type { Send } from 'types';
import { titleCase } from '../composables/titleCase';
import { ArchiveBoxIcon, ClockIcon, CloudIcon, EnvelopeIcon, ExclamationTriangleIcon, PencilSquareIcon } from '@heroicons/vue/24/outline';
import MessageGearsIcon from '../../svg/message-gears-icon.svg';

withDefaults(defineProps<{
    send: Send
    size?: 'sm'|'md'|'lg'
}>(), {
    size: 'md',
});

</script>

<template>
    <Badge
        v-if="send.status"
        :size="{
            'badge-xs': size === 'sm',
            'badge-md': size === 'md',
            'badge-lg': size === 'lg',
        }"
        :class="{
            'badge-neutral-500': send.status === 'draft', 
            'badge-amber-500': send.status === 'active',
            'badge-emerald-600': send.status === 'delivered',
            'badge-green-800': send.status === 'template',
            'badge-sky-600': send.status === 'queued',
            'badge-blue-800': send.status === 'scheduled',
            'badge-red-500': send.status === 'failed',
        }">
        <div class="gap-1 inline-flex items-center">
            <MessageGearsIcon
                v-if="send.status === 'template'"
                class="p-[1px]"
                :class="{
                    'w-3 h-3': size === 'sm',
                    'w-4 h-4': size === 'md',
                    'w-5 h-5': size === 'lg'
                }" />
            <EnvelopeIcon
                v-if="send.status === 'delivered'"
                :class="{
                    'w-3 h-3': size === 'sm',
                    'w-4 h-4': size === 'md',
                    'w-5 h-5': size === 'lg'
                }" />
            <ClockIcon
                v-if="send.status === 'scheduled'"
                :class="{
                    'w-3 h-3': size === 'sm',
                    'w-4 h-4': size === 'md',
                    'w-5 h-5': size === 'lg'
                }" />
            <ArchiveBoxIcon
                v-if="send.status === 'queued'"
                :class="{
                    'w-3 h-3': size === 'sm',
                    'w-4 h-4': size === 'md',
                    'w-5 h-5': size === 'lg'
                }" />
            <ExclamationTriangleIcon
                v-if="send.status === 'failed'"
                :class="{
                    'w-3 h-3': size === 'sm',
                    'w-4 h-4': size === 'md',
                    'w-5 h-5': size === 'lg'
                }" />
            <PencilSquareIcon
                v-if="send.status === 'draft'"
                :class="{
                    'w-3 h-3': size === 'sm',
                    'w-4 h-4': size === 'md',
                    'w-5 h-5': size === 'lg'
                }" />
            <CloudIcon
                v-if="send.status === 'active'"
                :class="{
                    'w-3 h-3': size === 'sm',
                    'w-4 h-4': size === 'md',
                    'w-5 h-5': size === 'lg'
                }" />
            {{ titleCase(send.status) }}
        </div>
    </Badge>
</template>